import React from 'react';

const PhoneIcon = function() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.9237 12.8746L12.3772 14.3403C11.9275 14.1846 10.6348 13.6632 9.45277 12.4812C8.34333 11.3718 7.87985 10.1465 7.74409 9.71846L9.21325 7.16672L6.01556 2.77405L5.67832 2.97293C4.31037 3.77537 3.30645 4.77929 2.52044 6.13081L2.47029 6.2683C2.02583 8.64103 3.38341 12.1379 5.8478 14.9715C8.51972 18.0429 11.9881 19.774 15.4322 19.774C15.5878 19.774 15.7435 19.7715 15.8991 19.7637L16.002 19.7593L16.0911 19.7092C17.4763 18.9327 18.4828 17.9262 19.2585 16.5409L19.4444 16.208L14.9237 12.8746Z"
        fill="#FEFEFE"
      />
    </svg>
  );
};

export default PhoneIcon;